import { css } from '@emotion/css';
import { NT70 } from '@julofinance/color-token';

export const stepCx = (step: number) => css`
  padding: 0.625rem 1rem;

  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid rgb(204, 204, 204);

  .back-btn {
    cursor: pointer;
    display: flex;
    margin-right: 0.625rem;
  }

  .progress {
    display: flex;
    margin-right: 1rem;
    user-select: none;
  }

  .step-title {
    flex: 1;
    width: 100%;

    h3 {
      font-weight: 700;
      line-height: 1.33;
      text-align: left;
      font-size: 1.125rem;
      color: ${step === 3 ? 'white' : '#5e5e5e'};
    }

    span {
      font-size: 12px;
      line-height: 17px;
      color: ${step === 3 ? 'white' : NT70};
    }
  }

  &:not(.with-progress) {
    padding: 1rem;

    .back-btn {
      margin-right: 0.75rem;
    }
  }
`;
